
import {
  SET_DIMENSIONS,
  SET_DIMENSION_POLICY_DATA,
  UPDATE_DIMENSION_FORM_ERROR,
  RESET_DIMENSION_POLICY_DATA,
  DIMENSION_MEMBERS_DATA,
  SET_HIERARCHIES,
  SET_DIMENSIONS_PAGE_DATA,
  RESET_DIMENSION_MEMBER_DATA,
  PAGINATED_DIMENSION_MEMBERS,
  DIMENSION_ATTRIBUTES
} from "./types";

interface HierarchyAllActions {
  [key: string]: {
    [key: string]: any;
  };
}

interface DimensionMembers {
  [key: string]: any[];
}

const initialState = {
  formValues: {
    policyName: '',
    policyDescription: '',
    dimension: null,
    attributes: [],
    hierarchy: null,
    selectAllDimension: false,
    members: null,
    action: [],
    dimensionAction: [],
    hierarchyAll: null,
    hierarchyAllActions: {} as HierarchyAllActions,
  },
  pagination: {},
  dimensionsList: [],
  dimensionAttributes: null,
  dimensionMembers: {} as DimensionMembers,
  dimensionFormError: {
    policyName: '',
    policyDescription: '',
    dimension: '',
    hierarchy: '',
    members: '',
    action: [],
    dimensionAction: [],
    hierarchyAll: [],
    hierarchyAllActions: {},
  }
};

export const dimensionReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_DIMENSIONS:
      return {
        ...state,
        dimensionsList: action.data.dimensions,
      };
    case SET_DIMENSION_POLICY_DATA:
      return {
        ...state,
        formValues: { ...state.formValues, ...action.data },
      };
    case UPDATE_DIMENSION_FORM_ERROR:
      return {
        ...state,
        entityFormError: { ...state.dimensionFormError, ...action.data }
      }
    case RESET_DIMENSION_POLICY_DATA:
      return {
        ...state,
        ...initialState
      }
    case SET_DIMENSIONS_PAGE_DATA:
      return {
        ...state,
        pagination: { ...state.pagination, [action.data.level]: action.data.page }
      }
    case DIMENSION_MEMBERS_DATA:
      if (!state.dimensionMembers[action.data.level]) {
        return {
          ...state,
          dimensionMembers: {
            ...state.dimensionMembers,
            ...action.data
          }
        }
      }
      return {
        ...state,
        dimensionMembers: {
          ...state.dimensionMembers,
          [action.data.level]: [
            ...state.dimensionMembers[action.data.level],
            ...action.data.members[action.data.level]
          ]
        }
      }
    case PAGINATED_DIMENSION_MEMBERS:
      return {
        ...state,
        dimensionMembers: {
          ...state.dimensionMembers,
          [action.data.level]: [
            ...state.dimensionMembers[action.data.level],
            ...action.data.members[action.data.level]
          ]
        }
      }
    case RESET_DIMENSION_MEMBER_DATA:
      return {
        ...state,
        dimensionMembers: {
          ...state.dimensionMembers,
          [action.data.level]: []
        },
        pagination: { ...initialState.pagination },
      }
    case SET_HIERARCHIES:
      const { id, value, name } = action.data

      const updatedData = {
        ...state,
        formValues: {
          ...state.formValues,
          hierarchyAllActions: {
            ...state.formValues.hierarchyAllActions,
            [id]: {
              ...state.formValues.hierarchyAllActions[id],
              [name]: name === 'actions' ? [...value] : value
            }
          }
        }
      };
      return { ...state, ...updatedData }

    case DIMENSION_ATTRIBUTES:
      return {
        ...state,
        dimensionAttributes: action.data.attributes
      };

    default:
      return state;
  }
};